<template>
  <div>
    <JsonEditor v-model="taskDefinition" />
    <button @click="createTaskDefinition(taskDefinition)">Create</button>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import JsonEditor from '@/components/JsonEditor.vue'

export default {
  name: 'TaskDefinitionCreate',
  data() {
    return {
      taskDefinition: {
        name: null
      }
    }
  },
  methods: mapActions(['createTaskDefinition']),
  components: {
    JsonEditor
  }
}
</script>
